export const operation = [
  { title: "新建空白应用", command: "addEmptyApp", icon: "empty-app" },
  { title: "从模板中心创建", command: "fromTemplateCenter", icon: "template" }
]
